<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h4 font-weight-bold text-primary">GoZhere Metro Manila</div>
                </b-col>
            </b-row>
            <b-row class="text-muted">
                <b-col/>
                <b-col>
                    Bulacan
                </b-col>
                <b-col>
                    Cavite
                </b-col>
                <b-col>
                    Laguna
                </b-col>
                <b-col>
                    Cebu
                </b-col>
                <b-col>
                    Davao
                </b-col>
                <b-col>
                    <b-icon icon="search" />
                    More Cities
                </b-col>
                <b-col/>
            </b-row>
            <b-row>
                <b-col>
                    <hr />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <HotAndNewBusinesses />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <RecentCollections />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    width: 100%;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

</style>

<script>
import HotAndNewBusinesses from './HotAndNewBusinesses'
import RecentCollections from './RecentCollections'

export default {
    components: {
        HotAndNewBusinesses,
        RecentCollections
    },
    data() {
        return {

        }
    }
}
</script>